import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFastRewind$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFastRewind extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '29c7481f943a69dad8b1c5dbb055ed4c23f61574', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '6eff93a8d070a13680fdb40e90b6eb3458d567e5', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '710e2d62c8138207d99f991dec30c04451acc345', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M18.5 5.48a.46.46 0 0 0-.22.06L12 10.47V6a.5.5 0 0 0-.5-.5.46.46 0 0 0-.22.06L5 10.47v-4A.5.5 0 0 0 4.5 6h-1a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-4l6.28 4.91a.6.6 0 0 0 .22 0A.5.5 0 0 0 12 16v-4.47l6.28 4.91a.6.6 0 0 0 .22 0A.5.5 0 0 0 19 16V6a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-fast-rewind", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-fast-rewind"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-fast-rewind":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFastRewind$1);
            }
            break;
    } });
}

const CosmosIconFastRewind = CosmosIconFastRewind$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFastRewind, defineCustomElement };
